// extracted by mini-css-extract-plugin
module.exports = {"LandingPage":"LandingPage_LandingPage__1WBKj","container":"LandingPage_container__1C8Y0"};